import { Plus, X } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { EditableText } from "@/components/EditableText";
import { Reveal } from "@/components/Reveal";

const About = () => {
  const { content, admin, addItem, removeItem } = useSite();
  return (
    <section id="about" data-testid="about-section" className="scroll-mt-16 px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div
            className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.3em] text-[#5C564D]"
            data-testid="about-eyebrow"
          >
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#078930]" aria-hidden="true" />
            <EditableText path="about.heading" testId="about-heading" />
          </div>
        </Reveal>
        <div className="mt-20 space-y-24 md:space-y-36">
          {content.about.chapters.map((ch, i) => (
            <div key={i} className="grid gap-6 md:grid-cols-[160px_1fr] md:gap-20" data-testid={`about-chapter-${i}`}>
              <Reveal>
                <span className="font-serif text-7xl leading-none text-[#1A1713]/15 md:text-9xl">{ch.num}</span>
              </Reveal>
              <Reveal delay={0.12}>
                <div className="max-w-xl pt-2 md:pt-6">
                  <h3 className="font-serif text-3xl tracking-tight md:text-4xl">
                    <EditableText path={`about.chapters.${i}.title`} testId={`about-chapter-title-${i}`} />
                  </h3>
                  <p className="mt-5 text-base leading-relaxed text-[#5C564D] md:text-lg">
                    <EditableText path={`about.chapters.${i}.body`} testId={`about-chapter-body-${i}`} multiline />
                  </p>
                  {admin && (
                    <button
                      data-testid={`about-remove-chapter-${i}`}
                      onClick={() => removeItem("about.chapters", i)}
                      className="mt-4 flex items-center gap-1 text-[11px] uppercase tracking-widest text-[#DA121A]"
                    >
                      <X className="h-3 w-3" /> Remove chapter
                    </button>
                  )}
                </div>
              </Reveal>
            </div>
          ))}
        </div>
        {admin && (
          <button
            data-testid="about-add-chapter"
            onClick={() =>
              addItem("about.chapters", {
                num: String(content.about.chapters.length + 1).padStart(2, "0"),
                title: "New chapter",
                body: "Write something lovely.",
              })
            }
            className="mt-16 flex items-center gap-1 text-[11px] uppercase tracking-widest text-[#078930]"
          >
            <Plus className="h-3 w-3" /> Add chapter
          </button>
        )}
      </div>
    </section>
  );
};

export default About;
